//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {mergeMap as _observableMergeMap, catchError as _observableCatch} from 'rxjs/operators';
import {Observable, throwError as _observableThrow, of as _observableOf, throwError} from 'rxjs';
import {Injectable, Inject, Optional} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse, HttpResponseBase} from '@angular/common/http';
import {BOKKZ_BASE_URL, BOKKZ_SERVICE_URL, FileResponse, Periode} from "./api.bokkz.services";


@Injectable({
  providedIn: 'root'
})
export class BokkzSalarisClient {
  private http: HttpClient;
  private baseUrl: string;
  private serviceUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BOKKZ_BASE_URL) baseUrl?: string,
    @Optional() @Inject(BOKKZ_SERVICE_URL) serviceUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    this.serviceUrl = serviceUrl !== undefined && serviceUrl !== null ? serviceUrl : '';
  }

  getProfielen(body?: RequestDto | undefined): Observable<string[]> {
      let url_ = this.serviceUrl + "/api/v1/lb/profiles";
      // let url_ = "http://localhost:8080/api/v1/lb/profiles";

      url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostProfiles(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostProfiles(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<string[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<string[]>;
    }));
  }

  protected processPostProfiles(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
        return _observableOf(resultdefault);
      }));
    }
  }

  getDienstverband(body?: ProfielDto | undefined): Observable<Dienstverband> {
      let url_ = this.serviceUrl + "/api/v1/lb/dienstverband";
  //  let url_ = 'http://localhost:8080/api/v1/lb/dienstverband';
      url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostDienstverband(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostDienstverband(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<Dienstverband>;
        }
      } else
        return _observableThrow(response_) as any as Observable<Dienstverband>;
    }));
  }

  protected processPostDienstverband(response: HttpResponseBase): Observable<Dienstverband> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
        return _observableOf(resultdefault);
      }));
    }
  }

  getCalculatedLoonstaat(body?: RequestDto | undefined): Observable<LoonStaat> {
    let url_ = this.serviceUrl + "/api/v1/lb/bereken";

    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostLoonstaat(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostLoonstaat(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<LoonStaat>;
        }
      } else
        return _observableThrow(response_) as any as Observable<LoonStaat>;
    }));
  }

  protected processPostLoonstaat(response: HttpResponseBase): Observable<LoonStaat> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoonStaat;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getAllEmployees(clientId: string): Observable<WerknemerEntity[]> {
    let url_ = this.baseUrl + "/api/v1/sst/employees/{clientId}";
    if (clientId === undefined || clientId === null) {
      throw new Error("The parameter 'clientId' must be defined.");
    }
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllEmployees(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllEmployees(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<WerknemerEntity[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<WerknemerEntity[]>;
    }));
  }

  protected processGetAllEmployees(response: HttpResponseBase): Observable<WerknemerEntity[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WerknemerEntity[];
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getOneEmployee(clientId: string, employeeId: string): Observable<WerknemerEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/employee/{clientId}/{employeeId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOneEmployee(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOneEmployee(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<WerknemerEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<WerknemerEntity>;
    }));
  }

  protected processGetOneEmployee(response: HttpResponseBase): Observable<WerknemerEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WerknemerEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param clientId
   * @param body (optional)
   * @return default response
   */
  postOneEmployee(clientId: string, body?: WerknemerEntity | undefined): Observable<WerknemerEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/employee/{clientId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostOneEmployee(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostOneEmployee(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<WerknemerEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<WerknemerEntity>;
    }));
  }

  protected processPostOneEmployee(response: HttpResponseBase): Observable<WerknemerEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WerknemerEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  deleteEmployee(clientId: string, employeeId: string): Observable<Response> {
    let url_ = this.baseUrl + "/api/v1/sst/employee/{clientId}/{employeeId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    url_ = url_.replace(/[?&]$/, "");

    const options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("delete", url_, options_).pipe(
      _observableMergeMap((response_: any) => {
        return this.processDeleteEmployee(response_);
      }),
      _observableCatch((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
          try {
            return this.processDeleteEmployee(response_ as any);
          } catch (e) {
            return _observableThrow(e) as any as Observable<Response>;
          }
        } else {
          return _observableThrow(response_) as any as Observable<Response>;
        }
      })
    );
  }

  protected processDeleteEmployee(response: HttpResponseBase): Observable<Response> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body :
      (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    if (status === 200 || status === 204) {
      return _observableOf(response as any);
    } else {
      return _observableThrow(response);
    }
  }

  /**
   * @return default response
   */
  getOneEmployer(clientId: string): Observable<WerkgeverEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/employer/{clientId}";
    if (clientId === undefined || clientId === null) {
      throw new Error("The parameter 'clientId' must be defined.");
    }
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOneEmployer(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOneEmployer(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<WerkgeverEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<WerkgeverEntity>;
    }));
  }

  protected processGetOneEmployer(response: HttpResponseBase): Observable<WerkgeverEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WerkgeverEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  postOneEmployer(clientId: string, sendToAuthorities: boolean, periode?: string, jaar?: string, body?: WerkgeverEntity | undefined): Observable<WerkgeverEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/employer/{clientId}/{sendToAuthorities}/{periode}/{jaar}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    if (sendToAuthorities === undefined || sendToAuthorities === null)
      throw new Error("The parameter 'sendToAuthorities' must be defined.");
    url_ = url_.replace("{sendToAuthorities}", encodeURIComponent("" + sendToAuthorities));
    if (periode !== undefined)
      url_ = url_.replace("{periode}", encodeURIComponent("" + periode));
    if (jaar !== undefined)
      url_ = url_.replace("{jaar}", encodeURIComponent("" + jaar));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostOneEmployer(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostOneEmployer(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<WerkgeverEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<WerkgeverEntity>;
    }));
  }

  protected processPostOneEmployer(response: HttpResponseBase): Observable<WerkgeverEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WerkgeverEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getOneLoonstaat(employeeId: number, year: string): Observable<LoonstaatEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/loonstaat/{employeeId}/{year}";
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    if (year === undefined || year === null)
      throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOneLoonstaat(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOneLoonstaat(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<LoonstaatEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<LoonstaatEntity>;
    }));
  }

  protected processGetOneLoonstaat(response: HttpResponseBase): Observable<LoonstaatEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoonstaatEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param clientId
   * @param employeeId
   * @param body (optional)
   * @return default response
   */
  postOneLoonstaat(clientId: string, employeeId: string, body?: LoonstaatEntity | undefined): Observable<LoonstaatEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/loonstaat/{clientId}/{employeeId}/";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);
    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostOneLoonstaat(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostOneLoonstaat(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<LoonstaatEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<LoonstaatEntity>;
    }));
  }

  protected processPostOneLoonstaat(response: HttpResponseBase): Observable<LoonstaatEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoonstaatEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  postOneCalculationRequest(clientId: string, periode?: string, jaar?: string, body?: WerkgeverEntity | undefined): Observable<LoonJournaal> {
    let url_ = this.baseUrl + "/api/v1/sst/employer/{clientId}/{periode}/{jaar}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    if (periode !== undefined)
      url_ = url_.replace("{periode}", encodeURIComponent("" + periode));
    if (jaar !== undefined)
      url_ = url_.replace("{jaar}", encodeURIComponent("" + jaar));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostOneCalculationRequest(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostOneCalculationRequest(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<LoonJournaal>;
        }
      } else
        return _observableThrow(response_) as any as Observable<LoonJournaal>;
    }));
  }

  protected processPostOneCalculationRequest(response: HttpResponseBase): Observable<LoonJournaal> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoonJournaal;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getSwagger(): Observable<void> {
    let url_ = this.baseUrl + "/api/v1/sst/openapi";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetSwagger(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSwagger(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processGetSwagger(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf(null as any);
      }));
    }
  }

  /**
   * @return default response
   */
  getExternalGrammar(path: string): Observable<FileResponse> {
    let url_ = this.baseUrl + "/application.wadl/{path}";
    if (path === undefined || path === null)
      throw new Error("The parameter 'path' must be defined.");
    url_ = url_.replace("{path}", encodeURIComponent("" + path));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetExternalGrammar(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetExternalGrammar(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileResponse>;
    }));
  }

  protected processGetExternalGrammar(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({fileName: fileName, data: responseBlob as any, status: status, headers: _headers});
    }
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
      return throwError(() => new Error(error.error.message));
    } else {
      console.error(`Backend returned code ${error.status}, body was: `, error.error);
      const backendMessage = error.error?.message || error.error || 'Er is iets misgegaan. Probeer het opnieuw.';
      return throwError(() => new Error(backendMessage));
    }
  }

  /**
   * @return default response
   */
  getWadl(): Observable<FileResponse> {
    let url_ = this.baseUrl + "/application.wadl";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetWadl(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetWadl(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileResponse>;
    }));
  }

  protected processGetWadl(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({fileName: fileName, data: responseBlob as any, status: status, headers: _headers});
    }
  }
}

export interface ProfielDto {
  reset: boolean,
  profielId: string,
  verloningstijdvak: WerkgeverAangifteTijdvak,
  geboortedatum: Date,
  burgerservicenummer: string,
  nummerIkv: number,
  datumInDienst: Date,
  bepaaldeTijdContract: boolean,
  lhkToepassen: boolean,
  sectorCode: string,
  caoCode: string,
  typePensioenregeling: string,
  rechtOpVakantiegeld: boolean,
  vakantiegeldBijAanvang: number,
  urenPerWeek: number,
  normuren: number,
  periodeVrijval: number,
  periodeSalaris: number,
  grondslagComponenten?: number[];
  percentage?: number;
}

export interface MemoriaalBoeking {
  boekingsdatum: string,
  omschrijving: string,
  dagboekId: string,
  debet: number,
  credit: number,
  markering: boolean,
  boekstuk: string,
  boekingsregels?: Boekingsregels[];
  werkgever: Werkgever
}

export interface Boekingsregels {
  omschrijving?: string,
  grootboekId?: string,
  kostenplaatsPublicIdentifier?: string | null,
  debet?: number,
  credit?: number,
  btwSoortDto?: BtwSoortDto,
  btwPercentage?: number,
  factuurId?: string,
  factuurNummer?: string
}

export enum BtwSoortDto {
  GEEN = "Geen",
}

export interface RequestDto {
  dienstverband?: Dienstverband;
  loonStaat?: LoonStaat;
  year?: number;

  [key: string]: any;
}

export interface ProfileSettings {
  verloningstijdvak: WerkgeverAangifteTijdvak,
  geboortedatum: Date,
  burgerservicenummer: string,
  nummerIkv: number,
  datumInDienst: Date,
  urenPerWeek: number,
  rechtOpVakantiegeld: boolean,
  reserveringVakantiegeld: number,
  typeProfiel: string,
  typePensioenregeling: string,
  periodeSalaris: number,
  sectorCode: string,
  caoCode: string,
  dienstverband?: Dienstverband;
  loonStaat?: LoonStaat;
  year?: number;

  [key: string]: any;
}

export interface Component1 {
  periode?: Periode;
  component?: Component2;
  displayValue?: string;
  eenheid?: number;
  bedrag?: number;
  percentage?: number;
  proRataVergoeding?: number;
  grondslagComponenten?: number[];
  periodeVrijval?: number;
  cumulatiefSaldoBeginPeriode?: number;
  berekendeAanwas?: number;
  cumulatiefSaldoEindPeriode?: number;

  [key: string]: any;
}

export interface ContractGegevens {
  periode?: Periode;
  soortInkomstenverhouding?: ContractGegevensSoortInkomstenverhouding;
  aardArbeidsverhouding?: ContractGegevensAardArbeidsverhouding;
  verzekeringssituatieZvw?: ContractGegevensVerzekeringssituatieZvw;
  invloedVerzekeringsplicht?: ContractGegevensInvloedVerzekeringsplicht;
  faseIndeling?: ContractGegevensFaseIndeling;
  bepaaldeTijd?: boolean;
  schriftelijkeOvereenkomst?: boolean;
  oproepovereenkomst?: boolean;
  jaarurennorm?: boolean;

  [key: string]: any;
}

export interface Dienstverband {
  profielId: string,
  bsn?: string;
  ikv?: string | number;
  geboorteDatum?: Date;
  datumInDienst?: Date;
  datumUitDienst?: Date;
  redenEindeArbeidsverhouding?: DienstverbandRedenEindeArbeidsverhouding;
  aangifteTijdvak?: WerkgeverAangifteTijdvak;
  aofVoorKleineWerkgeverToepassen?: boolean;
  contractGegevensList?: ContractGegevens[];
  werkrooster?: Werkrooster[];
  vasteVergoedingen?: Component1[];
  variabeleVergoedingen?: Component1[];
  regelingen?: Component1[];
  pensioenen?: PensioenRegeling[];
  fiscaleGegevens?: Fiscaal[];
  werknemerVerzekeringen?: WerknemerVerzekeringen[];
  loonstaat?: LoonstaatEntity;

  [key: string]: any;
}

export interface Excasso {
  iban?: string;

  [key: string]: any;
}

export interface Fiscaal {
  periode?: Periode;
  loonheffingskorting?: boolean;
  anoniemTarief?: boolean;
  tabelTariefAfwijkend?: number;
  jaarloonBijzonderTarief?: number;
  bijzonderTariefAfwijkend?: number;
  woonlandFiscaal?: FiscaalWoonlandFiscaal;
  herleidingssituatie?: FiscaalHerleidingssituatie;
  tabelKleur?: FiscaalTabelKleur;
  incidenteleInkomstenvermindering?: FiscaalIncidenteleInkomstenvermindering;

  [key: string]: any;
}

export interface PensioenRegeling {
  periode?: Periode;
  code?: string;

  [key: string]: any;
}

export interface PersoonSalaris {
  personeelsnummer?: string;
  personeelsnummerVerloning?: string;
  roepnaam?: string;
  voorletters?: string;
  tussenvoegsel?: string;
  achternaam?: string;
  naamVolledig?: string;
  geslacht?: PersoonGeslacht;
  geboortedatum?: Date;
  leeftijd?: number;
  datumIngangAOW?: Date;
  burgerservicenummer?: string;
  nationaliteit?: PersoonNationaliteit;
  postcode?: string;
  huisnummer?: number;
  toevoeging?: string;
  straatnaam?: string;
  plaats?: string;
  locatieomschrijving?: string;
  landcode?: PersoonLandcode;
  straatnaamBtl?: string;
  huisnummerBtl?: string;
  locatieomschrijvingBtl?: string;
  postcodeBtl?: string;
  woonplaatsBtl?: string;
  regionaamBtl?: string;
  telefoonnummer?: string;
  emailadres?: string;
  burgerlijkeStaat?: string;
  tussenvoegselPartner?: string;
  achternaamPartner?: string;
  gebruikAchternaam?: string;

  [key: string]: any;
}

export interface Werknemer {
  persoon?: PersoonSalaris;
  bankrekeningen?: Excasso;
  dienstverbanden?: Dienstverband[];

  [key: string]: any;
}

export interface WerknemerEntity {
  id?: number;
  taxId?: string;
  werknemerGegevens?: Werknemer;

  [key: string]: any;
}

export interface WerknemerVerzekeringen {
  periode?: Periode;
  naam?: string;
  wao?: boolean;
  ww?: boolean;
  zw?: boolean;
  sector?: string;
  cao?: string;

  [key: string]: any;
}

export interface Werkrooster {
  periode?: Periode;
  aantalUrenPerWeek?: number;
  normUren?: number;
  werkdagenEvenWeek?: WerkdagenEvenWeek[];
  werkdagenOnevenWeek?: WerkdagenOnevenWeek[];

  [key: string]: any;
}

export interface Werkgever {
  naamWerkgever?: string;
  loonheffingennummer?: string;
  periodeSalarisadministratie?: Periode;
  periodeLoonaangifte?: Periode;
  aangifteTijdvak?: WerkgeverAangifteTijdvak;
  settings?: WerkgeverSettings[];
  grootboekSettings?: GrootboekBoeking[];
  postcode?: string;
  huisnummer?: number;
  toevoeging?: string;
  straatnaam?: string;
  plaats?: string;
  land?: string;
  locatie?: string;
  telefoonnummer?: string;
  emailadres?: string;
  postbus?: string;
  kvkNummer?: string;
  sbi?: string;
  normuren?: number;

  [key: string]: any;
}

export interface WerkgeverEntity {
  id?: number;
  werkgeverGegevens?: Werkgever;
  taxId?: string;

  [key: string]: any;
}

export interface WerkgeverSettings {
  periode?: Periode;
  caoCode?: string;
  sectorCode?: string;
  kleineWerkgever?: boolean;
  pensioenCode?: string;
  whkPercentageWga?: number;
  whkPercentageWgaVerrekenen?: number;
  whkPercentageZw?: number;
  erdWga?: boolean;
  erdZw?: boolean;

  [key: string]: any;
}

export interface GrootboekBoeking {
  grootboeknummer?: string;
  grootboeknaam?: string;
  boekingType?: BoekingType;

  [key: string]: any;
}

export interface Journaalpost {
  grootboeknummer?: string;
  omschrijving?: string;
  bedragDebet?: number;
  bedragCredit?: number;

  [key: string]: any;
}

export interface LoonAangifteDto {
  aangifteTijdvak?: Periode;
  werkgever?: Werkgever;
  werknemerList?: Werknemer[]
}

export interface LoonStaat {
  bsn?: string;
  year?: number;
  verloningsPeriode?: VerloningsPeriode[];
  totalen?: VerloningsPeriode;

  [key: string]: any;
}


export interface JournaalPerWerknemer {
  runNummer?: string;
  personeelsnummerWerknemer?: string;
  naamWerknemer?: string;
  journaalposten?: Journaalpost[];

  [key: string]: any;
}

export interface LoonJournaal {
  periode?: Periode;
  uitersteBetaaldatum?: Date;
  betalingskenmerk?: string;
  teBetalen?: number;
  journaalpostenPerWerknemer?: JournaalPerWerknemer[];
  nettoLonen?: Journaalpost[];

  [key: string]: any;
}

// export interface Journaalpost {
//   grootboeknummer?: string;
//   omschrijving?: string;
//   bedragDebet?: number;
//   bedragCredit?: number;
//
//   [key: string]: any;
// }

export interface LoonstaatEntity {
  id?: number;
  taxId?: string;
  year?: number;
  loonStaat?: LoonStaat;

  [key: string]: any;
}

export interface VerloningsPeriode {
  afgesloten?: boolean;
  periode?: Periode;
  periodenummer?: number;
  runnummer?: number;
  loonComponenten?: Component1[];

  [key: string]: any;
}

export enum BoekingType {
  DEBET = "DEBET",
  CREDIT = "CREDIT",
}

export enum Component2 {
  UREN_GEWERKT = "UREN_GEWERKT",
  MEERUREN = "MEERUREN",
  UREN_OPNAME_VAKANTIE = "UREN_OPNAME_VAKANTIE",
  UREN_ZIEK = "UREN_ZIEK",
  WACHTUREN_ZIEK = "WACHTUREN_ZIEK",
  UREN_BETAALD_VERLOF = "UREN_BETAALD_VERLOF",
  UREN_ONBETAALD = "UREN_ONBETAALD",
  UREN_ARBEIDSTIJDVERKORTING = "UREN_ARBEIDSTIJDVERKORTING",
  UREN_UITBETALING_VAKANTIE = "UREN_UITBETALING_VAKANTIE",
  UREN_UITBETALING_TIJD_VOOR_TIJD = "UREN_UITBETALING_TIJD_VOOR_TIJD",
  UREN_AANKOOP_VERLOF = "UREN_AANKOOP_VERLOF",
  UREN_WERKGEVERSBETALING_UWV = "UREN_WERKGEVERSBETALING_UWV",
  UREN_BIJZONDER_VERLOF = "UREN_BIJZONDER_VERLOF",
  UREN_KORT_VERZUIM = "UREN_KORT_VERZUIM",
  UREN_FEESTDAGEN = "UREN_FEESTDAGEN",
  UREN_AANVULLEND_GEBOORTEVERLOF = "UREN_AANVULLEND_GEBOORTEVERLOF",
  UREN_OUDERSCHAPSVERLOF = "UREN_OUDERSCHAPSVERLOF",
  SALARIS = "SALARIS",
  PERSOONLIJKE_TOESLAG = "PERSOONLIJKE_TOESLAG",
  REISKOSTEN_BELAST = "REISKOSTEN_BELAST",
  PENSIOENPREMIE_WN = "PENSIOENPREMIE_WN",
  OUDERSCHAPSVERLOF = "OUDERSCHAPSVERLOF",
  OUDERDOMSPENSIOEN_UITKERING = "OUDERDOMSPENSIOEN_UITKERING",
  SALARIS_NABETALING = "SALARIS_NABETALING",
  STAGEVERGOEDING = "STAGEVERGOEDING",
  DIVERS_BRUTO_VERGOEDING_1 = "DIVERS_BRUTO_VERGOEDING_1",
  DIVERS_BRUTO_VERGOEDING_2 = "DIVERS_BRUTO_VERGOEDING_2",
  DIVERS_BRUTO_VERGOEDING_3 = "DIVERS_BRUTO_VERGOEDING_3",
  BONUS = "BONUS",
  EENMALIGE_UITKERING = "EENMALIGE_UITKERING",
  PROVISIE = "PROVISIE",
  AANZEGVERGOEDING = "AANZEGVERGOEDING",
  TRANSITIEVERGOEDING = "TRANSITIEVERGOEDING",
  ONTSLAGVERGOEDING = "ONTSLAGVERGOEDING",
  VAKANTIEGELD_HANDMATIG = "VAKANTIEGELD_HANDMATIG",
  FISCALE_BIJTELLING_AUTO = "FISCALE_BIJTELLING_AUTO",
  PRIVEKOSTEN_AUTO = "PRIVEKOSTEN_AUTO",
  FISCALE_BIJTELLING_FIETS = "FISCALE_BIJTELLING_FIETS",
  FISCALE_BIJTELLING_MOTOR = "FISCALE_BIJTELLING_MOTOR",
  FISCALE_BIJTELLING_DIVERS = "FISCALE_BIJTELLING_DIVERS",
  INHOUDING_WHK = "INHOUDING_WHK",
  ONKOSTENVERGOEDING_WKR = "ONKOSTENVERGOEDING_WKR",
  BIJDRAGE_AUTO_PRIVE = "BIJDRAGE_AUTO_PRIVE",
  INHOUDING_DIVERS = "INHOUDING_DIVERS",
  VOORSCHOT = "VOORSCHOT",
  REISKOSTEN_WOON_WERK_VAST = "REISKOSTEN_WOON_WERK_VAST",
  REISKOSTEN_WOON_WERK_VARIABEL = "REISKOSTEN_WOON_WERK_VARIABEL",
  REISKOSTEN_ZAKELIJK = "REISKOSTEN_ZAKELIJK",
  DAGGELD = "DAGGELD",
  LOONBESLAG = "LOONBESLAG",
  THUISWERKVERGOEDING = "THUISWERKVERGOEDING",
  PERSONEELSVERENIGING = "PERSONEELSVERENIGING",
  CAK_BIJDRAGE = "CAK_BIJDRAGE",
  INHOUDING_ALIMENTATIE = "INHOUDING_ALIMENTATIE",
  REISKOSTEN_PLAATSBEWIJS = "REISKOSTEN_PLAATSBEWIJS",
  DIVERS_NETTO_VERGOEDING_1 = "DIVERS_NETTO_VERGOEDING_1",
  DIVERS_NETTO_VERGOEDING_2 = "DIVERS_NETTO_VERGOEDING_2",
  DIVERS_NETTO_VERGOEDING_3 = "DIVERS_NETTO_VERGOEDING_3",
  NETTOLOON_NB = "NETTOLOON_NB",
  NETTO_DIVERS_NB = "NETTO_DIVERS_NB",
  BESTELAUTO_EINDHEFFING = "BESTELAUTO_EINDHEFFING",
  EINDHEFFING_WKR = "EINDHEFFING_WKR",
  EINDHEFFING_TIJDELIJKE_KNELPUNT = "EINDHEFFING_TIJDELIJKE_KNELPUNT",
  EINDHEFFING_VERSTREKKING_NIET_WERKNEMERS = "EINDHEFFING_VERSTREKKING_NIET_WERKNEMERS",
  EINDHEFFING_GOEDEREN_DIENSTEN_PROMOTIE = "EINDHEFFING_GOEDEREN_DIENSTEN_PROMOTIE",
  PSEUDO_EINDHEFFING_RVU = "PSEUDO_EINDHEFFING_RVU",
  EH_NIET_GEBRUIKEN = "EH_NIET_GEBRUIKEN",
  EINDHEFFING_NAHEFF_AANSLAG_TABELTARIEF = "EINDHEFFING_NAHEFF_AANSLAG_TABELTARIEF",
  EINDHEFFING_NAHEFF_AANSLAG_ENKELVOUDIG_TARIEF = "EINDHEFFING_NAHEFF_AANSLAG_ENKELVOUDIG_TARIEF",
  EINDHEFFING_PUBLIEKRECHT_UITKERING = "EINDHEFFING_PUBLIEKRECHT_UITKERING",
  VAKANTIEBIJSLAG = "VAKANTIEBIJSLAG",
  EINDEJAARSTOESLAG = "EINDEJAARSTOESLAG",
  BRUTOLOON_TOTAAL = "BRUTOLOON_TOTAAL",
  EINDHEFFINGSLOON_TOTAAL = "EINDHEFFINGSLOON_TOTAAL",
  HEFFINGSLOON = "HEFFINGSLOON",
  LOONHEFFING = "LOONHEFFING",
  BIJDRAGE_ZVW = "BIJDRAGE_ZVW",
  NETTOLOON = "NETTOLOON",
  SV_LOON = "SV_LOON",
  SV_LOON_MAX_PERIODE = "SV_LOON_MAX_PERIODE",
  GRONDSLAG_WERKNEMERVERZEKERINGEN = "GRONDSLAG_WERKNEMERVERZEKERINGEN",
  PREMIELOON_AWF_LAAG = "PREMIELOON_AWF_LAAG",
  AFDRACHT_AWF_LAAG = "AFDRACHT_AWF_LAAG",
  PREMIELOON_AWF_HOOG = "PREMIELOON_AWF_HOOG",
  AFDRACHT_AWF_HOOG = "AFDRACHT_AWF_HOOG",
  PREMIELOON_AWF_HERZIEN = "PREMIELOON_AWF_HERZIEN",
  AFDRACHT_AWF_HERZIEN = "AFDRACHT_AWF_HERZIEN",
  PREMIELOON_AWF_UITKERING = "PREMIELOON_AWF_UITKERING",
  AFDRACHT_AWF_UITKERING = "AFDRACHT_AWF_UITKERING",
  PREMIELOON_AOF_LAAG = "PREMIELOON_AOF_LAAG",
  AFDRACHT_AOF_LAAG = "AFDRACHT_AOF_LAAG",
  PREMIELOON_AOF_HOOG = "PREMIELOON_AOF_HOOG",
  AFDRACHT_AOF_HOOG = "AFDRACHT_AOF_HOOG",
  PREMIELOON_WKO = "PREMIELOON_WKO",
  AFDRACHT_WKO = "AFDRACHT_WKO",
  PREMIELOON_ZVW = "PREMIELOON_ZVW",
  ZVW_WERKGEVERSHEFFING = "ZVW_WERKGEVERSHEFFING",
  AFDRACHT_ZVW = "AFDRACHT_ZVW",
  PREMIELOON_WHK = "PREMIELOON_WHK",
  AFDRACHT_WHK = "AFDRACHT_WHK",
  ARBEIDSKORTING = "ARBEIDSKORTING",
  WERKGEVERKOSTEN = "WERKGEVERKOSTEN",
  VERLOONDE_UREN = "VERLOONDE_UREN",
  BRUTOLOON_TOTAAL_BIJZONDER_TARIEF = "BRUTOLOON_TOTAAL_BIJZONDER_TARIEF",
  HEFFINGSLOON_BIJZONDER_TARIEF = "HEFFINGSLOON_BIJZONDER_TARIEF",
  LOONHEFFING_BIJZONDER_TARIEF = "LOONHEFFING_BIJZONDER_TARIEF",
  RESERVERING_GRONDSLAG = "RESERVERING_GRONDSLAG",
  RESERVERING_BEDRAG = "RESERVERING_BEDRAG",
  EHGEBRAUTO = "EHGEBRAUTO",
  EHOVSFRFWRKKSTRG = "EHOVSFRFWRKKSTRG",
  EHPUBUITK = "EHPUBUITK",
  EHVUT = "EHVUT",
  EH_NAHEFF_AANSLAG_TABELTARIEF = "EH_NAHEFF_AANSLAG_TABELTARIEF",
  EH_NAHEFF_AANSLAG_ENKELVOUDIG_TARIEF = "EH_NAHEFF_AANSLAG_ENKELVOUDIG_TARIEF",
  WERKDAGEN = "WERKDAGEN",
  PREMIEVERVANGENDE_LOONBELASTING = "PREMIEVERVANGENDE_LOONBELASTING",
  BIJDRAGEVERVANGENDE_LOONBELASTING = "BIJDRAGEVERVANGENDE_LOONBELASTING",
  EINDJAARS_TOESLAG ="EINDJAARS_TOESLAG"
}

export enum ContractGegevensSoortInkomstenverhouding {
  LOON_SALARIS_AMBTENAREN = "LOON_SALARIS_AMBTENAREN",
  LOON_SALARIS_DIRECTEUREN_NV_BV_VERZEKERD = "LOON_SALARIS_DIRECTEUREN_NV_BV_VERZEKERD",
  LOON_SALARIS_OVERIG = "LOON_SALARIS_OVERIG",
  LOON_SALARIS_DGA_NIET_VERZEKERD = "LOON_SALARIS_DGA_NIET_VERZEKERD",
  WACHTGELD_OVERHEID = "WACHTGELD_OVERHEID",
  UITKERING_AOW = "UITKERING_AOW",
  OORLOGS_VERZETSPENSIOENEN = "OORLOGS_VERZETSPENSIOENEN",
  UITKERING_ANW = "UITKERING_ANW",
  UITKERING_ZW_WAZO = "UITKERING_ZW_WAZO",
  UITKERING_WAO_PARTICULIER = "UITKERING_WAO_PARTICULIER",
  UITKERING_NWW = "UITKERING_NWW",
  UITKERING_IOAW = "UITKERING_IOAW",
  UITKERING_WAZ = "UITKERING_WAZ",
  UITKERING_WAJONG = "UITKERING_WAJONG",
  SAMENLOOP_WAJONG_WAZ_WAO_WGA = "SAMENLOOP_WAJONG_WAZ_WAO_WGA",
  UITKERING_IVA = "UITKERING_IVA",
  UITKERING_WGA = "UITKERING_WGA",
  UITKERING_BBZ = "UITKERING_BBZ",
  UITKERING_PARTICIPATIEWET = "UITKERING_PARTICIPATIEWET",
  UITKERING_IOAZ = "UITKERING_IOAZ",
  UITKERING_TOESLAGENWET = "UITKERING_TOESLAGENWET",
  UITKERING_OVERIGE_SOCIALE_VERZEKERINGEN = "UITKERING_OVERIGE_SOCIALE_VERZEKERINGEN",
  UITKERING_IOW = "UITKERING_IOW",
  UITKERING_VERVROEGDE_UITTREDING = "UITKERING_VERVROEGDE_UITTREDING",
  UITKERING_APPA = "UITKERING_APPA",
  OUDERDOMSPENSIOEN_WERKGEVER = "OUDERDOMSPENSIOEN_WERKGEVER",
  NABESTAANDENPENSIOEN_WERKGEVER = "NABESTAANDENPENSIOEN_WERKGEVER",
  ARBEIDSONGESCHIKTHEIDSPENSIOEN_WERKGEVER = "ARBEIDSONGESCHIKTHEIDSPENSIOEN_WERKGEVER",
  LIJFRENTEN_ARBEIDSOVEREENKOMST = "LIJFRENTEN_ARBEIDSOVEREENKOMST",
  LIJFRENTEN_OVERIG = "LIJFRENTEN_OVERIG",
  AANVULLING_WERKGEVER_UITKERING = "AANVULLING_WERKGEVER_UITKERING",
  ONTSLAGVERGOEDING_TRANSITIEVERGOEDING = "ONTSLAGVERGOEDING_TRANSITIEVERGOEDING",
  OVERIGE_PENSIOENEN_LIJFRENTEN = "OVERIGE_PENSIOENEN_LIJFRENTEN",
}

export enum ContractGegevensAardArbeidsverhouding {
  ARBEIDSOVEREENKOMST = "ARBEIDSOVEREENKOMST",
  DEELVISSER = "DEELVISSER",
  MUSICUS_ARTIEST = "MUSICUS_ARTIEST",
  STAGIAIR = "STAGIAIR",
  UITZENDKRACHT = "UITZENDKRACHT",
  PUBLIEKRECHTELIJKE_AANSTELLING = "PUBLIEKRECHTELIJKE_AANSTELLING",
  WSW_BESCHUT_WERK = "WSW_BESCHUT_WERK",
  WSW_DETACHERING = "WSW_DETACHERING",
  WSW_BEGELEID_WERK = "WSW_BEGELEID_WERK",
  PARTICIPATIEWET_BESCHUT_WERK = "PARTICIPATIEWET_BESCHUT_WERK",
  OPTING_INREGELING = "OPTING_INREGELING",
  OVERIGE_FICTIEVE_DIENSTBETREKKINGEN = "OVERIGE_FICTIEVE_DIENSTBETREKKINGEN",
  PAYROLLING = "PAYROLLING",
  BEROEPSPRAKTIJKOPLEIDING_BBL = "BEROEPSPRAKTIJKOPLEIDING_BBL",
}

export enum ContractGegevensVerzekeringssituatieZvw {
  NIET_VERZEKERINGSPLICHTIG_WLZ = "NIET_VERZEKERINGSPLICHTIG_WLZ",
  NIET_VERZEKERINGSPLICHTIG_MILITAIR = "NIET_VERZEKERINGSPLICHTIG_MILITAIR",
  NIET_VERZEKERINGSPLICHTIG_BUITENLANDSE_ARTIEST_SPORTER = "NIET_VERZEKERINGSPLICHTIG_BUITENLANDSE_ARTIEST_SPORTER",
  WEL_VERZEKERINGSPLICHTIG_GEEN_TARIEF = "WEL_VERZEKERINGSPLICHTIG_GEEN_TARIEF",
  NIET_VERZEKERINGSPLICHTIG_PSEUDOBIJDRAGE = "NIET_VERZEKERINGSPLICHTIG_PSEUDOBIJDRAGE",
  WEL_VERZEKERINGSPLICHTIG_NORMAAL_TARIEF = "WEL_VERZEKERINGSPLICHTIG_NORMAAL_TARIEF",
  WEL_VERZEKERINGSPLICHTIG_NUL_TARIEF = "WEL_VERZEKERINGSPLICHTIG_NUL_TARIEF",
  WEL_VERZEKERINGSPLICHTIG_INGEHOUDEN_BIJDRAGE = "WEL_VERZEKERINGSPLICHTIG_INGEHOUDEN_BIJDRAGE",
  WEL_VERZEKERINGSPLICHTIG_MEER_TARIEVEN = "WEL_VERZEKERINGSPLICHTIG_MEER_TARIEVEN",
}

export enum ContractGegevensInvloedVerzekeringsplicht {
  ECHTGENOOT_FAMILIE = "ECHTGENOOT_FAMILIE",
  VORIGE_EIGENAAR = "VORIGE_EIGENAAR",
  OPROEP_INVALKRACHT_ZONDER_VERPLICHTING = "OPROEP_INVALKRACHT_ZONDER_VERPLICHTING",
  OPROEP_INVALKRACHT_MET_VERPLICHTING = "OPROEP_INVALKRACHT_MET_VERPLICHTING",
}

export enum ContractGegevensFaseIndeling {
  FASE_1_2_MET_UIZENDBEDING = "FASE_1_2_MET_UIZENDBEDING",
  FASE_3 = "FASE_3",
  FASE_4 = "FASE_4",
  WETTELIJK_REGIME = "WETTELIJK_REGIME",
  KETENSYSTEEM = "KETENSYSTEEM",
  FASE_A_MET_UIZENDBEDING = "FASE_A_MET_UIZENDBEDING",
  FASE_B = "FASE_B",
  FASE_C = "FASE_C",
  FASE_A_ZONDER_UIZENDBEDING_MET_UITSCHAKELING = "FASE_A_ZONDER_UIZENDBEDING_MET_UITSCHAKELING",
  FASE_A_ZONDER_UIZENDBEDING = "FASE_A_ZONDER_UIZENDBEDING",
  FASE_1_2_ZONDER_UIZENDBEDING = "FASE_1_2_ZONDER_UIZENDBEDING",
  FASE_1_2_ZONDER_UIZENDBEDING_MET_UITSCHAKELING = "FASE_1_2_ZONDER_UIZENDBEDING_MET_UITSCHAKELING",
}

export enum DienstverbandRedenEindeArbeidsverhouding {
    OPZEGGING_ONT_SLAG_PROEFTIJD = "OPZEGGING_ONT_SLAG_PROEFTIJD",
    ONTBINDING_RECHTER_WERKGEVER = "ONTBINDING_RECHTER_WERKGEVER",
    BEËINDIGING_WEDERZIJDS_GOEDVINDEN = "BEËINDIGING_WEDERZIJDS_GOEDVINDEN",
    OPZEGGING_LANGDURIGE_ARBEIDSONGESCHIKTHEID = "OPZEGGING_LANGDURIGE_ARBEIDSONGESCHIKTHEID",
    OPZEGGING_BEDRIJFSECONOMISCHE_REDENEN = "OPZEGGING_BEDRIJFSECONOMISCHE_REDENEN",
    EINDE_OPZEGGING_WERKNEMER = "EINDE_OPZEGGING_WERKNEMER",
    OPZEGGING_DRINGENDE_REDEN = "OPZEGGING_DRINGENDE_REDEN",
    EINDE_VERSTRIJKEN_DUUR = "EINDE_VERSTRIJKEN_DUUR",
    EINDE_VAN_RECHTSWEGE_VANWEGE_PENSIONERING = "EINDE_VAN_RECHTSWEGE_VANWEGE_PENSIONERING",
    EINDE_VAN_RECHTSWEGE_VANWEGE_OVERLIJDEN = "EINDE_VAN_RECHTSWEGE_VANWEGE_OVERLIJDEN",
    EINDE_VAN_RECHTSWEGE_VANWEGE_OM_ANDERE_REDEN = "EINDE_VAN_RECHTSWEGE_VANWEGE_OM_ANDERE_REDEN",
    EINDE_UIZENDOVEREEENKOMST_ZIEKTE = "EINDE_UIZENDOVEREEENKOMST_ZIEKTE",
    EINDE_UIZENDOVEREEENKOMST_ANDERE_REDEN = "EINDE_UIZENDOVEREEENKOMST_ANDERE_REDEN",
    ONTSLAG_PUBLIEKRECHTELIJK_ONBEKWAAMHEID = "ONTSLAG_PUBLIEKRECHTELIJK_ONBEKWAAMHEID",
    ONTSLAG_PUBLIEKRECHTELIJK_LEEFTIJD = "ONTSLAG_PUBLIEKRECHTELIJK_LEEFTIJD",
    ARBEIDSVERHOUDING_LOOPT_DOOR_ADMIN_BEEINDIGD = "ARBEIDSVERHOUDING_LOOPT_DOOR_ADMIN_BEEINDIGD",
    ARBEIDSVERHOUDING_NIEUWE_WERKGEVER = "ARBEIDSVERHOUDING_NIEUWE_WERKGEVER",
    ARBEIDSVERHOUDING_ZONDER_ONDERBREKING = "ARBEIDSVERHOUDING_ZONDER_ONDERBREKING",
    ANDERE_REDEN = "ANDERE_REDEN",
}


export enum DienstverbandAangifteTijdvak {
  VIER_WEKEN = "VIER_WEKEN",
  MAAND = "MAAND",
  KWARTAAL = "KWARTAAL",
  WEEK = "WEEK",
  DAG = "DAG",
  JAAR = "JAAR",
}

export enum FiscaalWoonlandFiscaal {
  NEDERLAND = "NEDERLAND",
  BELGIE = "BELGIE",
  LANDENKRING = "LANDENKRING",
  SURINAME_EN_ARUBA = "SURINAME_EN_ARUBA",
  DERDE_LANDEN = "DERDE_LANDEN",
}

export enum FiscaalHerleidingssituatie {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
  F = "F",
  G = "G",
  H = "H",
}

export enum FiscaalTabelKleur {
  WIT = "WIT",
  GROEN = "GROEN",
}

export enum FiscaalIncidenteleInkomstenvermindering {
  KINDVERLOF = "KINDVERLOF",
  ONBETAALD_VERLOF = "ONBETAALD_VERLOF",
  STAKINGSDAGEN = "STAKINGSDAGEN",
  ZIEKTE = "ZIEKTE",
}

export enum PersoonGeslacht {
  ONBEKEND = "ONBEKEND",
  MAN = "MAN",
  VROUW = "VROUW",
  NIET_GESPECIFICEERD = "NIET_GESPECIFICEERD",
}

export enum PersoonNationaliteit {
  NEDERLANDSE = "NEDERLANDSE",
  AFGHAANSE = "AFGHAANSE",
  ALBANESE = "ALBANESE",
  ALGERIJNSE = "ALGERIJNSE",
  AMERIKAANS_BURGER = "AMERIKAANS_BURGER",
  AMERIKAANS_ONDERDAAN = "AMERIKAANS_ONDERDAAN",
  ANDORRESE = "ANDORRESE",
  ANGOLESE = "ANGOLESE",
  ARGENTIJNSE = "ARGENTIJNSE",
  ARMEENSE = "ARMEENSE",
  AUSTRALISCHE = "AUSTRALISCHE",
  AZERBEIDZJAANSE = "AZERBEIDZJAANSE",
  BAHAMAANSE = "BAHAMAANSE",
  BAHREINSE = "BAHREINSE",
  BARBADAANSE = "BARBADAANSE",
  BELARUSSISCHE = "BELARUSSISCHE",
  BELGISCHE = "BELGISCHE",
  BELIZAANSE = "BELIZAANSE",
  BENGALESE = "BENGALESE",
  BENINSE = "BENINSE",
  BHUTAANSE = "BHUTAANSE",
  BOLIVIAANSE = "BOLIVIAANSE",
  BOTSWAANSE = "BOTSWAANSE",
  BRAZILIAANSE = "BRAZILIAANSE",
  BRITISH_NATIONAL_OVERSEAS = "BRITISH_NATIONAL_OVERSEAS",
  BRITS_BURGER = "BRITS_BURGER",
  BRITS_ONDERDAAN = "BRITS_ONDERDAAN",
  BRITS_OVERZEES_BURGER = "BRITS_OVERZEES_BURGER",
  BRUNEISE = "BRUNEISE",
  BULGAARSE = "BULGAARSE",
  BURGER_VAN_ANTIGUA_EN_BARBUDA = "BURGER_VAN_ANTIGUA_EN_BARBUDA",
  BURGER_VAN_BOSNIË_HERZEGOVINA = "BURGER_VAN_BOSNIË_HERZEGOVINA",
  BURGER_VAN_BRITSE_AFHANKELIJKE_GEBIEDEN = "BURGER_VAN_BRITSE_AFHANKELIJKE_GEBIEDEN",
  BURGER_VAN_CONGO = "BURGER_VAN_CONGO",
  BURGER_VAN_DE_BONDSREPUBLIEK_DUITSLAND = "BURGER_VAN_DE_BONDSREPUBLIEK_DUITSLAND",
  BURGER_VAN_DE_VERENIGDE_ARABISCHE_EMIRATEN = "BURGER_VAN_DE_VERENIGDE_ARABISCHE_EMIRATEN",
  BURGER_VAN_DEMOCRATISCHE_REPUBLIEK_CONGO = "BURGER_VAN_DEMOCRATISCHE_REPUBLIEK_CONGO",
  BURGER_VAN_DOMINICA = "BURGER_VAN_DOMINICA",
  BURGER_VAN_SAINT_KITTS_EN_NEVIS = "BURGER_VAN_SAINT_KITTS_EN_NEVIS",
  BURGER_VAN_SAINT_VINCENT_EN_DE_GRENADINES = "BURGER_VAN_SAINT_VINCENT_EN_DE_GRENADINES",
  BURGER_VAN_SÃO_TOMÉ_EN_PRINCIPE = "BURGER_VAN_SÃO_TOMÉ_EN_PRINCIPE",
  BURGER_VAN_TIMOR_LESTE = "BURGER_VAN_TIMOR_LESTE",
  BURGER_VAN_TRINIDAD_EN_TOBAGO = "BURGER_VAN_TRINIDAD_EN_TOBAGO",
  BURKINESE = "BURKINESE",
  BURUNDESE = "BURUNDESE",
  CAMBODJAANSE = "CAMBODJAANSE",
  CANADESE = "CANADESE",
  CENTRAAL_AFRIKAANSE = "CENTRAAL_AFRIKAANSE",
  CHILEENSE = "CHILEENSE",
  CHINESE = "CHINESE",
  COLOMBIAANSE = "COLOMBIAANSE",
  COMORESE = "COMORESE",
  COSTA_RICAANSE = "COSTA_RICAANSE",
  CUBAANSE = "CUBAANSE",
  CYPRISCHE = "CYPRISCHE",
  DEENSE = "DEENSE",
  DJIBOUTIAANSE = "DJIBOUTIAANSE",
  DOMINICAANSE = "DOMINICAANSE",
  ECUADORAANSE = "ECUADORAANSE",
  EGYPTISCHE = "EGYPTISCHE",
  EQUATORIAAL_GUINESE = "EQUATORIAAL_GUINESE",
  ERITRESE = "ERITRESE",
  ESTISCHE = "ESTISCHE",
  ESWATINISCHE = "ESWATINISCHE",
  ETHIOPISCHE = "ETHIOPISCHE",
  FIJISCHE = "FIJISCHE",
  FILIPIJNSE = "FILIPIJNSE",
  FINSE = "FINSE",
  FRANSE = "FRANSE",
  GABONESE = "GABONESE",
  GAMBIAANSE = "GAMBIAANSE",
  GEORGISCHE = "GEORGISCHE",
  GHANESE = "GHANESE",
  GRENADAANSE = "GRENADAANSE",
  GRIEKSE = "GRIEKSE",
  GUATEMALAANSE = "GUATEMALAANSE",
  GUINEE_BISSAUSE = "GUINEE_BISSAUSE",
  GUINESE = "GUINESE",
  GUYAANSE = "GUYAANSE",
  HAÏTIAANSE = "HAÏTIAANSE",
  HONDURESE = "HONDURESE",
  HONGAARSE = "HONGAARSE",
  IERSE = "IERSE",
  IJSLANDSE = "IJSLANDSE",
  INDIASE = "INDIASE",
  INDONESISCHE = "INDONESISCHE",
  IRAAKSE = "IRAAKSE",
  IRAANSE = "IRAANSE",
  ISRAËLISCHE = "ISRAËLISCHE",
  ITALIAANSE = "ITALIAANSE",
  IVORIAANSE = "IVORIAANSE",
  JAMAICAANSE = "JAMAICAANSE",
  JAPANSE = "JAPANSE",
  JEMENITISCHE = "JEMENITISCHE",
  JORDAANSE = "JORDAANSE",
  KAAPVERDISCHE = "KAAPVERDISCHE",
  KAMEROENSE = "KAMEROENSE",
  KAZACHSE = "KAZACHSE",
  KENYAANSE = "KENYAANSE",
  KIRGIZISCHE = "KIRGIZISCHE",
  KIRIBATISCHE = "KIRIBATISCHE",
  KOEWEITSE = "KOEWEITSE",
  KOSOVAARSE = "KOSOVAARSE",
  KROATISCHE = "KROATISCHE",
  LAOTIAANSE = "LAOTIAANSE",
  LESOTHAANSE = "LESOTHAANSE",
  LETSE = "LETSE",
  LIBANESE = "LIBANESE",
  LIBERIAANSE = "LIBERIAANSE",
  LIBISCHE = "LIBISCHE",
  LIECHTENSTEINSE = "LIECHTENSTEINSE",
  LITOUWSE = "LITOUWSE",
  LUXEMBURGSE = "LUXEMBURGSE",
  MACEDONISCHE_BURGER_VAN_NOORD_MACEDONIË = "MACEDONISCHE_BURGER_VAN_NOORD_MACEDONIË",
  MALAGASSISCHE = "MALAGASSISCHE",
  MALAWISCHE = "MALAWISCHE",
  MALDIVISCHE = "MALDIVISCHE",
  MALEISISCHE = "MALEISISCHE",
  MALINESE = "MALINESE",
  MALTESE = "MALTESE",
  MAROKKAANSE = "MAROKKAANSE",
  MARSHALLEILANDSE = "MARSHALLEILANDSE",
  MAURITAANSE = "MAURITAANSE",
  MAURITIAANSE = "MAURITIAANSE",
  MEXICAANSE = "MEXICAANSE",
  MICRONESISCHE = "MICRONESISCHE",
  MOLDAVISCHE = "MOLDAVISCHE",
  MONEGASKISCHE = "MONEGASKISCHE",
  MONGOLISCHE = "MONGOLISCHE",
  MONTENEGRIJNSE = "MONTENEGRIJNSE",
  MOZAMBIKAANSE = "MOZAMBIKAANSE",
  MYANMARESE = "MYANMARESE",
  NAMIBISCHE = "NAMIBISCHE",
  NAURUAANSE = "NAURUAANSE",
  NEPALESE = "NEPALESE",
  NICARAGUAANSE = "NICARAGUAANSE",
  NIEUW_ZEELANDSE = "NIEUW_ZEELANDSE",
  NIGERESE = "NIGERESE",
  NIGERIAANSE = "NIGERIAANSE",
  NOORD_KOREAANSE = "NOORD_KOREAANSE",
  NOORSE = "NOORSE",
  OEKRAÏENSE = "OEKRAÏENSE",
  OEZBEEKSE = "OEZBEEKSE",
  OMAANSE = "OMAANSE",
  OOSTENRIJKSE = "OOSTENRIJKSE",
  PAKISTAANSE = "PAKISTAANSE",
  PALAUSE = "PALAUSE",
  PANAMESE = "PANAMESE",
  PAPOEA_NIEUW_GUINESE = "PAPOEA_NIEUW_GUINESE",
  PARAGUAYAANSE = "PARAGUAYAANSE",
  PERUAANSE = "PERUAANSE",
  POOLSE = "POOLSE",
  PORTUGESE = "PORTUGESE",
  QATARESE = "QATARESE",
  ROEMEENSE = "ROEMEENSE",
  RUSSISCHE = "RUSSISCHE",
  RWANDESE = "RWANDESE",
  SAINT_LUCIAANSE = "SAINT_LUCIAANSE",
  SALOMONSEILANDSE = "SALOMONSEILANDSE",
  SALVADORAANSE = "SALVADORAANSE",
  SAMOAANSE = "SAMOAANSE",
  SAN_MARINESE = "SAN_MARINESE",
  SAOEDI_ARABISCHE = "SAOEDI_ARABISCHE",
  SENEGALESE = "SENEGALESE",
  SERVISCHE = "SERVISCHE",
  SEYCHELSE = "SEYCHELSE",
  SIERRA_LEOONSE = "SIERRA_LEOONSE",
  SINGAPORESE = "SINGAPORESE",
  SLOVEENSE = "SLOVEENSE",
  SLOWAAKSE = "SLOWAAKSE",
  SOEDANESE = "SOEDANESE",
  SOMALISCHE = "SOMALISCHE",
  SPAANSE = "SPAANSE",
  SRI_LANKAANSE = "SRI_LANKAANSE",
  STAATLOOS = "STAATLOOS",
  SURINAAMSE = "SURINAAMSE",
  SYRISCHE = "SYRISCHE",
  TADZJIEKSE = "TADZJIEKSE",
  TAIWANESE = "TAIWANESE",
  TANZANIAANSE = "TANZANIAANSE",
  THAISE = "THAISE",
  TOGOLESE = "TOGOLESE",
  TONGAANSE = "TONGAANSE",
  TSJADISCHE = "TSJADISCHE",
  TSJECHISCHE = "TSJECHISCHE",
  TUNESISCHE = "TUNESISCHE",
  TURKMEENSE = "TURKMEENSE",
  TURKSE = "TURKSE",
  TUVALUAANSE = "TUVALUAANSE",
  UGANDESE = "UGANDESE",
  URUGUAYAANSE = "URUGUAYAANSE",
  VANUATUAANSE = "VANUATUAANSE",
  VATICAANSE = "VATICAANSE",
  VENEZOLAANSE = "VENEZOLAANSE",
  VIETNAMESE = "VIETNAMESE",
  ZAMBIAANSE = "ZAMBIAANSE",
  ZIMBABWAANSE = "ZIMBABWAANSE",
  ZUID_AFRIKAANSE = "ZUID_AFRIKAANSE",
  ZUID_KOREAANSE = "ZUID_KOREAANSE",
  ZUID_SOEDANESE = "ZUID_SOEDANESE",
  ZWEEDSE = "ZWEEDSE",
  ZWITSERSE = "ZWITSERSE",
  ONBEKEND = "ONBEKEND",
}

export enum PersoonLandcode {
  NL = "NL",
  AD = "AD",
  AE = "AE",
  AF = "AF",
  AG = "AG",
  AI = "AI",
  AL = "AL",
  AM = "AM",
  AO = "AO",
  AQ = "AQ",
  AR = "AR",
  AS = "AS",
  AT = "AT",
  AU = "AU",
  AW = "AW",
  AX = "AX",
  AZ = "AZ",
  BA = "BA",
  BB = "BB",
  BD = "BD",
  BE = "BE",
  BF = "BF",
  BG = "BG",
  BH = "BH",
  BI = "BI",
  BJ = "BJ",
  BL = "BL",
  BM = "BM",
  BN = "BN",
  BO = "BO",
  BQ = "BQ",
  BR = "BR",
  BS = "BS",
  BT = "BT",
  BV = "BV",
  BW = "BW",
  BY = "BY",
  BZ = "BZ",
  CA = "CA",
  CC = "CC",
  CD = "CD",
  CF = "CF",
  CG = "CG",
  CH = "CH",
  CI = "CI",
  CK = "CK",
  CL = "CL",
  CM = "CM",
  CN = "CN",
  CO = "CO",
  CR = "CR",
  CU = "CU",
  CV = "CV",
  CW = "CW",
  CX = "CX",
  CY = "CY",
  CZ = "CZ",
  DE = "DE",
  DJ = "DJ",
  DK = "DK",
  DM = "DM",
  DO = "DO",
  DZ = "DZ",
  EC = "EC",
  EE = "EE",
  EG = "EG",
  EH = "EH",
  ER = "ER",
  ES = "ES",
  ET = "ET",
  FI = "FI",
  FJ = "FJ",
  FK = "FK",
  FM = "FM",
  FO = "FO",
  FR = "FR",
  GA = "GA",
  GB = "GB",
  GD = "GD",
  GE = "GE",
  GF = "GF",
  GG = "GG",
  GH = "GH",
  GI = "GI",
  GL = "GL",
  GM = "GM",
  GN = "GN",
  GP = "GP",
  GQ = "GQ",
  GR = "GR",
  GS = "GS",
  GT = "GT",
  GU = "GU",
  GW = "GW",
  GY = "GY",
  HK = "HK",
  HM = "HM",
  HN = "HN",
  HR = "HR",
  HT = "HT",
  HU = "HU",
  ID = "ID",
  IE = "IE",
  IL = "IL",
  IM = "IM",
  IN = "IN",
  IO = "IO",
  IQ = "IQ",
  IR = "IR",
  IS = "IS",
  IT = "IT",
  JE = "JE",
  JM = "JM",
  JO = "JO",
  JP = "JP",
  KE = "KE",
  KG = "KG",
  KH = "KH",
  KI = "KI",
  KM = "KM",
  KN = "KN",
  KP = "KP",
  KR = "KR",
  KW = "KW",
  KY = "KY",
  KZ = "KZ",
  LA = "LA",
  LB = "LB",
  LC = "LC",
  LI = "LI",
  LK = "LK",
  LR = "LR",
  LS = "LS",
  LT = "LT",
  LU = "LU",
  LV = "LV",
  LY = "LY",
  MA = "MA",
  MC = "MC",
  MD = "MD",
  ME = "ME",
  MF = "MF",
  MG = "MG",
  MH = "MH",
  MK = "MK",
  ML = "ML",
  MM = "MM",
  MN = "MN",
  MO = "MO",
  MP = "MP",
  MQ = "MQ",
  MR = "MR",
  MS = "MS",
  MT = "MT",
  MU = "MU",
  MV = "MV",
  MW = "MW",
  MX = "MX",
  MY = "MY",
  MZ = "MZ",
  NA = "NA",
  NC = "NC",
  NE = "NE",
  NF = "NF",
  NG = "NG",
  NI = "NI",
  NO = "NO",
  NP = "NP",
  NR = "NR",
  NU = "NU",
  NZ = "NZ",
  OM = "OM",
  PA = "PA",
  PE = "PE",
  PF = "PF",
  PG = "PG",
  PH = "PH",
  PK = "PK",
  PL = "PL",
  PM = "PM",
  PN = "PN",
  PR = "PR",
  PS = "PS",
  PT = "PT",
  PW = "PW",
  PY = "PY",
  QA = "QA",
  RE = "RE",
  RO = "RO",
  RS = "RS",
  RU = "RU",
  RW = "RW",
  SA = "SA",
  SB = "SB",
  SC = "SC",
  SD = "SD",
  SE = "SE",
  SG = "SG",
  SH = "SH",
  SI = "SI",
  SJ = "SJ",
  SK = "SK",
  SL = "SL",
  SM = "SM",
  SN = "SN",
  SO = "SO",
  SR = "SR",
  SS = "SS",
  ST = "ST",
  SV = "SV",
  SX = "SX",
  SY = "SY",
  SZ = "SZ",
  TC = "TC",
  TD = "TD",
  TF = "TF",
  TG = "TG",
  TH = "TH",
  TJ = "TJ",
  TK = "TK",
  TL = "TL",
  TM = "TM",
  TN = "TN",
  TO = "TO",
  TR = "TR",
  TT = "TT",
  TV = "TV",
  TW = "TW",
  TZ = "TZ",
  UA = "UA",
  UG = "UG",
  UM = "UM",
  US = "US",
  UY = "UY",
  UZ = "UZ",
  VA = "VA",
  VC = "VC",
  VE = "VE",
  VG = "VG",
  VI = "VI",
  VN = "VN",
  VU = "VU",
  WF = "WF",
  WS = "WS",
  XK = "XK",
  YE = "YE",
  YT = "YT",
  ZA = "ZA",
  ZM = "ZM",
  ZW = "ZW",
}

export enum WerkdagenEvenWeek {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
}

export enum WerkdagenOnevenWeek {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
}

export enum WerkgeverAangifteTijdvak {
  VIER_WEKEN = "VIER_WEKEN",
  MAAND = "MAAND",
  KWARTAAL = "KWARTAAL",
  WEEK = "WEEK",
  DAG = "DAG",
  JAAR = "JAAR",
}


class SwaggerException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: {
  [key: string]: any;
}, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return _observableThrow(result);
  else
    return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
